import React, { useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import FeatherIcon from 'feather-icons-react';

export default function SortProductTypesView(props) {
    const { productFilters, setProductFilters } = props
    const [hasPageContentChanged, setHasPageContentChanged] = useState(false)

    function pageContentChanged() {
        if (!hasPageContentChanged) {
            setHasPageContentChanged(true)
        }
    }
    const onDragEnd = result => {
        pageContentChanged()
        const { destination, source } = result
        if (!destination) {
            return;
        }
        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }
        const COPY_AllFields = Array.from(productFilters)
        const [removedItem] = COPY_AllFields.splice(source.index, 1)
        COPY_AllFields.splice(destination.index, 0, removedItem)
        setProductFilters(COPY_AllFields)
    }
    return (
        <React.Fragment>
            <div className="app-card mb-3 mb-lg-4" >
                <div className="product-filter-card ">
                    <div className="card-product-type flex-column pad-15-L pad-15-R">
                        <p className="product-filter-subheading">
                            Sort product filters
                        </p>
                        <DragDropContext
                            onDragEnd={onDragEnd}
                        >
                            <Droppable droppableId={"sortProductFilter"}>
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        className={`all-form-fields media-body content-inner ${snapshot.isDraggingOver ? "dragging-over" : ""}`}>
                                        {
                                            (productFilters && productFilters.length > 0) && productFilters.map((e, index) => {
                                                return (
                                                    <Draggable key={e.name} draggableId={e.name} index={index}>
                                                        {(provided, snapshot) => (
                                                            <div
                                                                {...provided.dragHandleProps}
                                                                {...provided.draggableProps}
                                                                ref={provided.innerRef}
                                                                className={`form-item-outer d-flex align-items-center justify-content-between flex-wrap ${snapshot.isDragging ? "dragging " : ''} ${e.enable === "0" ? "disabled-text" : ""}`}>
                                                                {/* move icon */}

                                                                <div className="d-flex align-items-center">
                                                                    <div>
                                                                        <FeatherIcon
                                                                            icon="slash"
                                                                            size="40"
                                                                            className={`icon me-4 ${e.enable === "0" ? "" : "text-primary"}`} />
                                                                    </div>
                                                                    <div>{e.name}</div>
                                                                </div>
                                                                <div className="move-icon" >
                                                                    <FeatherIcon
                                                                        icon="move"
                                                                        size="20"
                                                                        className="icon" />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                )
                                            })
                                        }
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}